import { render, staticRenderFns } from "./userorder.vue?vue&type=template&id=33dae6a2&scoped=true"
import script from "./userorder.vue?vue&type=script&lang=js"
export * from "./userorder.vue?vue&type=script&lang=js"
import style0 from "./userorder.vue?vue&type=style&index=0&id=33dae6a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dae6a2",
  null
  
)

export default component.exports